"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnMouseOver = void 0;
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function useOnMouseOver(onMouseOver) {
    const map = useOLMap_1.useOLMap();
    const onMouseOverRef = react_1.useRef(onMouseOver);
    react_1.useEffect(() => {
        onMouseOverRef.current = onMouseOver;
    }, [onMouseOver]);
    react_1.useEffect(() => {
        const onMouseOver = () => {
            onMouseOverRef.current();
        };
        map.getViewport().addEventListener('mouseout', onMouseOver);
        return () => map.getViewport().removeEventListener('mouseout', onMouseOver);
    }, [map]);
}
exports.useOnMouseOver = useOnMouseOver;
//# sourceMappingURL=useOnMouseOver.js.map